import axios from 'axios';


window.getCookie = function(name) {
	let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	if (match) return match[2];
}

//Internal Request
window.axios = axios;

let token = getCookie('IMC_API')
const $api = axios.create({
	baseURL : "https://api-zozenko.timc.biz/api/v1/",
});
$api.interceptors.request.use((config) => {
	config.headers['Authorization'] = 'Bearer ' + token;
	config.headers['Accept'] = 'application/json';
	//config.headers['Content-Type'] = 'application/json';

	return config;
});

$api.CancelToken = axios.CancelToken.source();
window.api = $api;

const portal = axios.create({
	withCredentials: true,
});

portal.interceptors.request.use((config) => {
	config.headers['Accept'] = 'application/json';
	//config.headers['Content-Type'] = 'application/json';
	return config;
});

portal.CancelToken = axios.CancelToken.source();
window.portal_api = portal;







